import { render, staticRenderFns } from "./SettingsEcommecer.vue?vue&type=template&id=fdb2bb64&scoped=true&"
import script from "./SettingsEcommecer.vue?vue&type=script&lang=js&"
export * from "./SettingsEcommecer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb2bb64",
  null
  
)

export default component.exports